import { Alert } from "@mui/material";

import { ShipmentTrackingLinkPanel } from "components/ShipmentTrackingLink";
import { useCarrierShipmentPageContext } from "hooks";
import { carrierHasBookingWriteAccess } from "utils";

interface Props {
  dividerComponent: JSX.Element;
}

export function ShipmentTrackingLinkSection(props: Props) {
  const { dividerComponent } = props;
  const { shipment, onRefresh } = useCarrierShipmentPageContext();

  if (!carrierHasBookingWriteAccess(shipment)) {
    return null;
  }

  const { link_expected: linkExpected, link_due: linkDue } =
    shipment?.tracking_link_info ?? {};

  return (
    <ShipmentTrackingLinkPanel
      dividerComponent={dividerComponent}
      shipment={shipment}
      onRefresh={onRefresh}
      showWarningOnCopy={false}
      addButtonLabel="Add Tracking Link"
      addPromptComponent={
        linkExpected && linkDue ? (
          <Alert severity="warning">
            Pick-up date for shipment date has arrived. Shipper is expecting a
            tracking link.
          </Alert>
        ) : null
      }
    />
  );
}
